import React, { useEffect, useState, useCallback } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { api } from "@/lib/api";
import { AlertStreamProvider, useAlertStreamContext } from "@/context/AlertStreamContext";

function PageLayoutInner() {
  const [serverUnacked, setServerUnacked] = useState(0);
  const stream = useAlertStreamContext();

  const refreshAlertCount = useCallback(async () => {
    try {
      const r = await api.get("/alerts");
      setServerUnacked(r.data.filter((a) => !a.acknowledged).length);
    } catch (e) {
      /* silently ignore — could be 401 mid-refresh */
    }
  }, []);

  useEffect(() => {
    refreshAlertCount();
    // Server poll once a minute as a safety net even with WS connected
    const t = setInterval(refreshAlertCount, 60000);
    return () => clearInterval(t);
  }, [refreshAlertCount]);

  // When a live ack arrives, resync the unacked count from the server immediately.
  useEffect(() => {
    if (stream.alerts.some((a) => a.acknowledged)) {
      refreshAlertCount();
    }
  }, [stream.alerts, refreshAlertCount]);

  // Live count = baseline unacked + new alerts received via WS that aren't acked
  const liveStreamUnacked = stream.alerts.filter((a) => !a.acknowledged).length;
  const sidebarCount = Math.max(serverUnacked, liveStreamUnacked, stream.newAlertCount);

  return (
    <div className="min-h-screen relative">
      <Sidebar alertCount={sidebarCount} connectionStatus={stream.connectionStatus} />
      <main className="ml-[240px] page-content min-h-screen" data-testid="main-content">
        <Outlet context={{ refreshAlertCount }} />
      </main>
    </div>
  );
}

export default function PageLayout() {
  return (
    <AlertStreamProvider>
      <PageLayoutInner />
    </AlertStreamProvider>
  );
}
